import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";

export default function AndarBahar150Cards() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "ab4"
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };

  

  useEffect(() => {
    // console.log("casinoData?.data?.response?.oddDetailsDTOS?.slice(1,13)", casinoData?.data?.response?.oddDetailsDTOS?.slice(0,13));
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
    // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
    //  VIDEO_ID={GAME_ID}
    // GAME_ID={GAME_ID}
    // shortName={"cards32a cards32b"}
    // gameName={"CARDS 32B"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container ab ab3"> */}
      {/* <div className="casino-header"> */}
      {/* <span className="casino-name">
            ANDAR BAHAR 150 CARDS
            <a className="ms-1">
              <small>Rules</small>
            </a>
          </span>
          <span className="casino-rid d-none d-xl-inline-block">
            <small>
              Round ID: <span>5250425152957</span>
            </small>
          </span> */}
      {/* </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none">
          <ul className="nav nav-tabs menu-tabs">
            <li className="nav-item">
              <div className="nav-link active">Game</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Placed Bet (0)</div>
            </li>
          </ul>
          <div className="pe-2">
            <span className="casino-rid">
              Round ID: <span>5250425152957</span>
            </span>
          </div>
        </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container">
              <div className="casino-video-box">
              </div>
            </div> */}
      {/* <div className="casino-video-cards"> */}
      {/* <span className="text-white">
                Next Card Count: <span className="text-warning">75 / Andar</span>
              </span> */}
      {/* <div className="ab-cards-container">
                <h5>Andar</h5>
                <div className="ms-4">
                  <div className="slick-slider slick-initialized" dir="ltr">
                    <button
                      type="button"
                      data-role="none"
                      className="slick-arrow slick-prev"
                      style={{ display: "block" }}
                    >
                      {" "}
                      {getOddForEntity(
                        casinoData?.data?.response?.oddDetailsDTOS[0]
                          ?.runnerName,
                        casinoData,
                        false
                      )}
                    </div>
                    <div>
                      {getOddForEntity(
                        `Andar ${
                          item == 11
                            ? "J"
                            : item == 12
                            ? "Q"
                            : item == 13
                            ? "K"
                            : item
                        }`,
                        casinoData,
                        true,
                        false,
                        true
                      ) == "SUSPENDED" &&
                      !baharCardsList?.includes(
                        String(
                          item == 11
                            ? "J"
                            : item == 12
                            ? "Q"
                            : item == 13
                            ? "K"
                            : item
                        )
                      ) ? (
                        <img
                          src={`https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/${0}.jpg`}
                          alt=""
                        />
                      ) : (
                        <img
                          src={`https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/${index +1}.jpg`}
                          alt=""
                        />
                      )}
                    </div>
                    <div className="casino-nation-book">
                      {getCasinoPlExposureByRunner(
                        casinoPlData,
                        `Andar ${
                          item == 11
                            ? "J"
                            : item == 12
                            ? "Q"
                            : item == 13
                            ? "K"
                            : item
                        }`
                      )}
                      
                    </div>
                  </div>
                ))} */}
                {/* <div
                  className={`card-odd-box  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet(
                      casinoData?.data?.response?.oddDetailsDTOS[0]?.runnerName,
                      casinoData,
                      dispatch,
                      "back"
                    )
                  }
                >
                  <div className="casino-odds">
                    {" "}
                    {getOddForEntity(
                      casinoData?.data?.response?.oddDetailsDTOS[0]?.runnerName,
                      casinoData,
                      false
                    )}
                  </div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/1.jpg" 
                    alt=""/>
                  </div>
                  <div className="casino-nation-book">
                    <span className="text-danger">
                      {" "}
                      {getCasinoPlExposureByRunner(
                        casinoPlData,
                        casinoData?.data?.response?.oddDetailsDTOS[0]
                          ?.runnerName
                      )}
                    </span>
                  </div>
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">1</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/2.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">2</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/3.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">4</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/4.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">2</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/5.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">0</div>
                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">2</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/7.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">1</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/8.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">0</div>
                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">0</div>
                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">1</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/11.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">0</div>
                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">1</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/13.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div> */}
         
      {/* </div> */}
      {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">8</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">8</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">7</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">7</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
      {/* </div> */}
      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-box">

            <div
              className={`andar-box ${casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""
                }`}
            >
              <div className="ab-title">ANDAR</div>
              <div className="ab-cards">
                <div className="card-odd-box  ">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Andar A/84", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Andar A/84", casinoData, true)}
                    </span>
                  </div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/1.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Andar 2/144", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Andar 2/144", casinoData, true)}
                    </span>
                  </div>                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/2.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Andar 3/35", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Andar 3/35", casinoData, true)}
                    </span>
                  </div>                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/3.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Andar 4/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Andar 4/42", casinoData, true)}
                    </span>
                  </div>                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/4.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Andar 5/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Andar 5/42", casinoData, true)}
                    </span>
                  </div>                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/5.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Andar 6/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Andar 6/42", casinoData, true)}
                    </span>
                  </div>                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/6.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Andar 7/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Andar 7/42", casinoData, true)}
                    </span>
                  </div>                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/7.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Andar 8/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Andar 8/42", casinoData, true)}
                    </span>
                  </div>                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/8.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Andar 9/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Andar 9/42", casinoData, true)}
                    </span>
                  </div>                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/9.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Andar 10/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Andar 10/42", casinoData, true)}
                    </span>
                  </div>                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/10.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Andar J/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Andar J/42", casinoData, true)}
                    </span>
                  </div>                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/11.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Andar Q/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Andar Q/42", casinoData, true)}
                    </span>
                  </div>                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/12.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Andar K/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Andar K/42", casinoData, true)}
                    </span>
                  </div>                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/13.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
              </div>
            </div>
            <div
              className={`bahar-box ${casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""
                }`}
            >
              <div className="ab-title">BAHAR</div>
              <div className="ab-cards">
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Bahar A/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Bahar A/42", casinoData, true)}
                    </span>
                  </div>                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Bahar 2/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Bahar 2/42", casinoData, true)}
                    </span>
                  </div>                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Bahar 3/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Bahar 3/42", casinoData, true)}
                    </span>
                  </div>                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Bahar 4/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Bahar 4/42", casinoData, true)}
                    </span>
                  </div>                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Bahar 5/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Bahar 5/42", casinoData, true)}
                    </span>
                  </div>                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Bahar 6/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Bahar 6/42", casinoData, true)}
                    </span>
                  </div>                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Bahar 7/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Bahar 7/42", casinoData, true)}
                    </span>
                  </div>                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Bahar 8/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Bahar 8/42", casinoData, true)}
                    </span>
                  </div>                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Bahar 9/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Bahar 9/42", casinoData, true)}
                    </span>
                  </div>                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Bahar 10/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Bahar 10/42", casinoData, true)}
                    </span>
                  </div>                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Bahar J/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Bahar J/42", casinoData, true)}
                    </span>
                  </div>                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Bahar Q/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Bahar Q/42", casinoData, true)}
                    </span>
                  </div>                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div
                    className="casino-odds-box back"
                    onClick={() =>
                      setBet("Bahar K/42", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Bahar K/42", casinoData, true)}
                    </span>
                  </div>                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/ab3">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
            </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
      {/* </div> */}
    </CasinoPage>

  )
}
